module.exports = __webpack_public_path__ + "img/mypage-active.ac152e52.png";